export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/shared/enums/CartItemType.ts